import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function Register() {
  const { register } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success('Compte créé !');
      nav('/');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Échec de la création');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-5 py-8"
      style={{ background: 'linear-gradient(160deg, #1E3A8A 0%, #2563EB 35%, #DC2626 100%)' }}
      data-testid="register-screen"
    >
      <div className="w-full max-w-[440px]">
        <div className="flex flex-col items-center mb-10">
          <img
            src="/brand/autoradko-wordmark.jpg"
            alt="Auto Radko"
            className="w-full max-w-[320px] rounded-2xl shadow-2xl mb-6 select-none"
            draggable={false}
          />
          <p className="text-sm font-semibold text-white/90 mt-1">Créez votre compte en 30 secondes.</p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <label className="block text-xs font-bold text-white mb-1.5 uppercase tracking-wider">Nom</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3.5 bg-black/80 text-white placeholder-white/40 border-2 border-white/20 rounded-xl focus:ring-2 focus:ring-white focus:border-white outline-none font-medium backdrop-blur-sm"
              placeholder="Jean Dupont"
              data-testid="register-name"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-white mb-1.5 uppercase tracking-wider">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3.5 bg-black/80 text-white placeholder-white/40 border-2 border-white/20 rounded-xl focus:ring-2 focus:ring-white focus:border-white outline-none font-medium backdrop-blur-sm"
              placeholder="vous@exemple.com"
              data-testid="register-email"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-white mb-1.5 uppercase tracking-wider">Mot de passe</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3.5 bg-black/80 text-white placeholder-white/40 border-2 border-white/20 rounded-xl focus:ring-2 focus:ring-white focus:border-white outline-none font-medium backdrop-blur-sm"
              placeholder="Minimum 6 caractères"
              data-testid="register-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-white text-blue-700 font-bold py-3.5 rounded-xl hover:bg-white/90 transition active:scale-[0.98] disabled:opacity-60 flex items-center justify-center gap-2 shadow-lg"
            data-testid="register-submit"
          >
            {loading && <Loader2 size={18} className="animate-spin" />} Créer mon compte
          </button>
          <p className="text-sm text-center text-white font-semibold pt-2">
            Déjà inscrit ?{' '}
            <Link to="/login" className="text-white font-extrabold underline decoration-2" data-testid="link-login">
              Se connecter
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
